import fuan from "./fuan";
import dx from "./dx";
import hj from "./hj";
import dw from "./dw";
import kr from "./kr";
import sz from "./sz";
import ld from "./ld";
import jt from "./jt";
import hp from "./hp";
import yl from "./yl";
import lt from "./lt";
import sx from "./sx";
import zblb from "./zblb";
import xnyy from "./xnyy";
const totalData = {
	0: fuan,
	1: dx,
	3: hj,
	4: dw,
	5: kr,
	6: sz,
	7: ld,
	8: jt,
	9: hp,
	10: yl,
	11: lt,
	12: sx,
	zblb: zblb,
	xnyy: xnyy
};

const field = [
	'homeData',
	'listData',
	'productDetailsData',
	'contactListData',
	'caseData',
	'evaluationData',
	'successfulBidderData',
	'lawData',
	'tipData',
];
export let allData = {};

const setAllData = () => {
	if(Object.keys(allData).length === 0){
		let tempObj = {};
		field.forEach(val => {
			let tempArr = [];
			for(let id in totalData){
				let value = totalData[id];
				tempArr.push({
					id: id,
					value: value[val]
				})
			}
			tempObj[val] = tempArr;
		})
		allData = tempObj;
	}
}

export const getHeaderTitle = (id) => {
	return (getItem("homeData", id) || {}).headerTitle || "陕建云采";
};

export const getItem = (type, id) => {
	setAllData();
	let obj = {};
	for (let i = 0, len = allData[type].length; i < len; i++) {
		let item = allData[type][i];
		if (item.id == id) {
			obj = item.value;
			break;
		}
	}
	return obj;
};

export const getData = (type) => {
	setAllData();
	return allData[type];
};
